module.exports = __webpack_public_path__ + "react05.60865e01bce9ca9780ff83395e27911b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/react05.svg
// module id = 863
// module chunks = 0